import { render, staticRenderFns } from "./QuestionnaireList.vue?vue&type=template&id=10309ed9&scoped=true&"
import script from "./QuestionnaireList.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireList.vue?vue&type=style&index=0&id=10309ed9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10309ed9",
  null
  
)

export default component.exports